export type ChatTab = "messages" | "bans";

export const DEFAULT_CHAT_TAB: ChatTab = "messages";

export function parseChatTab(value: string | null): ChatTab {
  return value === "bans" ? "bans" : DEFAULT_CHAT_TAB;
}

/**
 * Параметры адресной строки, которые относятся к вкладке сообщений: при
 * переходе на «Баны» они сбрасываются, всё остальное в URL остаётся (как в
 * Chargebacks.tsx). `contentIds` встречается и массивом, и одиночным
 * значением, поэтому чистим обе формы.
 */
export const CHAT_MESSAGES_PARAMS = [
  "page",
  "filter[search]",
  "filter[contentIds]",
  "filter[contentIds][]",
];
